import * as React from 'react';
import { TvComparisonContext } from './index';
const NecessitiesInfo = (props) => {
    const { content, headingLevel = 4 } = props;
    const { viewingNecessitiesLabel } = React.useContext(TvComparisonContext);
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: `h${headingLevel}` }, viewingNecessitiesLabel),
        content));
};
export default NecessitiesInfo;
